import { createContext, PropsWithChildren, useContext } from 'react';

import { ElevioAccountIntegration } from './hooks';

export type ElevioIntegrationContextValue = ElevioAccountIntegration;

type ElevioIntegrationState = {
  elevioIntegration: ElevioIntegrationContextValue;
};

export const ElevioIntegrationContext = createContext<ElevioIntegrationState>({
  elevioIntegration: undefined,
});

export const useElevioIntegration = (): ElevioIntegrationState =>
  useContext(ElevioIntegrationContext);

export function ElevioIntegrationProvider({
  elevioIntegration,
  children,
}: PropsWithChildren<ElevioIntegrationState>): JSX.Element {
  return (
    <ElevioIntegrationContext.Provider value={{ elevioIntegration }}>
      {children}
    </ElevioIntegrationContext.Provider>
  );
}
